<footer class="footer text-white py-4 px-4">
    <div class="container-fluid px-4">
        <div class="row">
            <!-- Logo (Mobile) -->
            <div class="col-12 mb-4 text-start d-lg-none">
                <img src="assets/images/vida-optima-footer-logo.svg" alt="Vida Óptima" class="footer-logo">
            </div>
        </div>

        <div class="row">
            <!-- Logo (Desktop) -->
            <div class="col-lg-4 mb-4 text-start d-none d-lg-block">
                <img src="assets/images/vida-optima-footer-logo.svg" alt="Vida Óptima" class="footer-logo">
            </div>

            <!-- Contacto -->
            <div class="col-12 col-lg-4">
                <h6 class="mb-3 fw-bold text-start fs-6">Nuestros canales</h6>
                <div class="d-flex flex-column gap-2 pb-2">
                    <div class="d-flex align-items-center">
                        <i class="bi bi-clock me-2"></i>
                        <span class="fs-7 ms-2">{{ contactInfo.horario }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                        <i class="bi bi-telephone me-2"></i>
                        <a [href]="'tel:' + contactInfo.phone" class="text-white text-decoration-none fs-7 ms-2">
                            {{ contactInfo.phone | mask: '(000) 000-0000' }}
                        </a>
                    </div>
                </div>

                <h6 class="mt-4 mb-3 fw-bold text-start fs-6">Nuestras oficinas</h6>
                <div>
                    <!-- Santo Domingo -->
                    <div>
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <span class="fw-bold fs-6">Santo Domingo</span>
                            <a [href]="contactInfo.mapUrlSantoDomingo" target="_blank" rel="noopener noreferrer"
                                class="text-white text-decoration-none fs-7 d-flex align-items-center gap-1 office-map-link">
                                Abrir en mapa
                                <i class="bi bi-box-arrow-up-right"></i>
                            </a>
                        </div>
                        <p class="fs-7 mb-0 opacity-100">{{ contactInfo.direccion }}</p>
                    </div>

                    <hr class="offices-separator">

                    <!-- Santiago -->
                    <div>
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <span class="fw-bold fs-6">Santiago</span>
                            <a [href]="contactInfo.mapUrlSantiago" target="_blank" rel="noopener noreferrer"
                                class="text-white text-decoration-none fs-7 d-flex align-items-center gap-1 office-map-link">
                                Abrir en mapa
                                <i class="bi bi-box-arrow-up-right"></i>
                            </a>
                        </div>
                        <p class="fs-7 mb-0 opacity-100">{{ contactInfo.direccionSantiago }}</p>
                    </div>
                </div>
            </div>

            <!-- Síguenos -->
            <div class="col-12 col-lg-4 mb-4 mt-3 mt-md-0">
                <h6 class="mb-3 fw-bold text-start text-lg-end fs-6">Síguenos</h6>
                <div class="d-flex gap-3 justify-content-start justify-content-lg-end">
                    <a *ngFor="let social of socialLinks" [href]="social.url" [attr.aria-label]="social.label"
                        target="_blank" rel="noopener noreferrer">
                        <img [src]="social.icon" class="social-icon" />
                    </a>
                </div>
            </div>
        </div>

        <!-- Enlaces de políticas (solo mobile) -->
        <div class="row d-lg-none">
            <div class="col-12 mb-3">
                <div class="d-flex flex-column gap-2 align-items-start footer-links-mobile">
                    <a *ngFor="let link of footerLinks" href="javascript:void(0)" data-bs-toggle="modal"
                        data-bs-target="#footerContentModal" (click)="openModal(link.key, link.text)"
                        class="text-white text-decoration-none footer-link-btn">
                        {{ link.text }}
                    </a>
                </div>
            </div>
        </div>

        <hr class="my-4 separator">

        <div class="row">
            <!-- Copyright -->
            <div class="col-12 col-lg-3 mb-3 mb-lg-0 text-start">
                <p class="mb-0 fs-7">
                    Copyright © AFP Popular
                </p>
            </div>

            <!-- Enlaces de políticas (desktop) -->
            <div class="col-lg-6 d-none d-lg-block">
                <div class="d-flex flex-wrap gap-3 justify-content-lg-start footer-links">
                    <a *ngFor="let link of footerLinks" href="javascript:void(0)" data-bs-toggle="modal"
                        data-bs-target="#footerContentModal" (click)="openModal(link.key, link.text)"
                        class="text-white text-decoration-none fs-7 footer-link-btn">
                        {{ link.text }}
                    </a>
                </div>
            </div>

            <!-- Botón Superintendencia -->
            <div class="col-12 col-lg-3 text-start text-lg-end">
                <a href="#"
                    class="btn btn-light text-secondary-400 fs-7 px-2 py-2 btn-superintendencia w-100 w-lg-auto">
                    Superintendencia de Pensiones
                </a>
            </div>
        </div>
    </div>
</footer>

<!-- Modal contenido footer -->
<div class="modal fade" id="footerContentModal" tabindex="-1" aria-labelledby="footerModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header border-bottom py-2">
                <h6 class="modal-title fw-bold text-secondary-400 mb-0" id="footerModalLabel">
                    {{ activeModalTitle }}
                </h6>
                <button type="button" class="btn-close text-secondary-400" data-bs-dismiss="modal"
                    aria-label="Cerrar"></button>
            </div>
            <div class="modal-body p-3 fs-7 footer-modal-body">
                @switch (activeModal) {
                @case ('politicas-privacidad') {
                <div class="text-secondary-400">
                    <p>
                        Honrando el compromiso de salvaguardar la información de sus clientes, AFP Popular le
                        proporciona
                        seguridad,
                        privacidad, confiabilidad e integridad para cada transacción en la Internet. En tal sentido, a
                        continuación se
                        presenta la Política de Seguridad de la página en red <a href="http://www.vidaoptimapopular.com"
                            target="_blank">www.vidaoptimapopular.com</a>.
                    </p>
                    <p>
                        La información que suministre la AFP Popular es confidencial; su uso obedece a lo establecido en
                        la
                        Ley 87-01,
                        regulaciones establecidas por la Superintendencia de Pensiones y a un austero Código de Ética.
                        La
                        información
                        sólo será divulgada cuando la Ley así lo requiera a través de la Superintendencia de Pensiones.
                    </p>
                    <p>
                        Usted puede visitar la página en red y encontrar información acerca de los productos y servicios
                        disponibles,
                        sin necesidad de facilitar información alguna sobre su persona.
                    </p>
                </div>
                }
                @case ('terminos-condiciones') {
                <div class="text-secondary-400">
                    <h5>Parámetros de Seguridad</h5>
                    <p>
                        AFP Popular ha diseñado una sofisticada arquitectura tecnológica compuesta por varios mecanismos
                        los
                        cuales, en
                        combinación, protegen su información y previenen intrusiones en el sistema. Éstos son:
                    </p>
                    <ul class="ps-3 list-unstyled">
                        <li class="mb-2">
                            <span class="fw-medium">Nombre de usuario (username):</span> Es el nombre único y visible
                            creado por Ud.,
                            como titular de
                            la
                            cuenta, para fines
                            de
                            acceso, seguridad, contabilidad, etc. frente al sistema y se compone de letras, números o
                            una
                            combinación de
                            ambos.
                        </li>
                        <li class="mb-2">
                            <span class="fw-medium">Contraseña (password):</span> Es una serie de caracteres secretos
                            que, a modo de llave de entrada,
                            le
                            garantizan
                            privacidad
                            en el acceso a su cuenta. También se forma con letras, números o una combinación de éstos.
                        </li>
                        <li class="mb-2">
                            <span class="fw-medium">Identificación Bloqueada:</span> Al tercer (3) intento fallido de
                            registro (incapacidad de
                            identificar
                            correctamente su
                            nombre de usuario y contraseña) el sistema bloqueará completamente el acceso a su cuenta.
                            Para
                            reestablecer el
                            acceso electrónico llame al (809) 544.7777 ó al 1.809.200.7767 desde el interior sin cargos.
                        </li>
                        <li class="mb-2">
                            <span class="fw-medium">Pared de Fuego (Firewall):</span> Equipos que custodian la
                            integridad del flujo de información
                            generada
                            cuando Ud. se
                            registra, solicita información o realiza cualesquier transacciones financieras, previniendo
                            e
                            interceptando la
                            filtración de datos.
                        </li>
                        <li class="mb-2">
                            <span class="fw-medium">Zona de Conexión Segura (Secure Socket Layer):</span> Es un área de
                            alta seguridad, proporcionada
                            por
                            el
                            servidor que
                            alberga la página en red del banco, en la cual podrá realizar transacciones comerciales con
                            capacidad para
                            codificar
                            según el método criptográfico de 128 bits, garantizando así privacidad en la transmisión de
                            datos.
                        </li>
                        <li class="mb-2">
                            <span class="fw-medium">Certificado de Seguridad Digital (Digital Security
                                Certificate):</span> El Popular utiliza como
                            proveedor
                            de
                            criptografía a
                            VeriSign para solucionar los requisitos de autentificación y certificación en las
                            transacciones
                            electrónicas. El
                            criptograma se completa cuando aparece el ícono de candado en la barra inferior derecha de
                            su
                            monitor.
                        </li>
                        <li class="mb-2">
                            <span class="fw-medium">Sistema para la Detección de Intrusos en la Red (Network
                                Intrusión Detection System, NIDS):</span>
                            Estos
                            programas
                            funcionan como centinelas ya que se instalan en los servidores para repeler ataques,
                            intrusiones
                            o
                            intentos de
                            acceso sin autorización. Periódicamente se implementan nuevas actualizaciones para mantener
                            la
                            protección de
                            éstos
                            vigente.
                        </li>
                        <li>
                            <span class="fw-medium">Centro de Monitoreo: </span> A través de un sistema que opera las
                            veinticuatro (24) horas, los siete
                            (7)
                            días de la
                            semana,
                            un dedicado equipo vigila cualesquier alertas, intentos de acceso sin autorización, ataques
                            y
                            demás
                            actividades
                            sospechosas.
                        </li>
                    </ul>
                </div>
                }
                @case ('politicas-uso') {
                <div class="text-secondary-400">
                    <p>
                        Con el objetivo de poseer información estadística sobre el uso de nuestra página web, utilizamos
                        la
                        herramienta Google Analytics, la cual nos proporciona información sobre el tráfico de la página,
                        y
                        de
                        las secciones más utilizadas por sus visitantes.
                    </p>
                    <p>
                        Al acceder a nuestra página y proporcionarnos sus datos personales, manifiesta su aceptación a
                        la
                        Política de Privacidad aquí consignada, nos autoriza para el siguiente uso de su información: a)
                        para el
                        fin mismo por lo cual se ha suministrado; b) para considerarlo dentro de nuestras estadísticas
                        de
                        tráfico, c) para orientar mejor los servicios aquí ofrecidos y valorarlos a su criterio, y d)
                        para
                        enviar e-mails con nuestros boletines, responder inquietudes o comentarios, y mantener informado
                        a
                        nuestros usuarios.
                    </p>
                    <div class="mt-3">
                        <h5>Uso de los <i>cookies</i>:</h5>
                        <p>
                            El uso de cookies y su dirección IP, tomados por este sitio, se realiza solo con la
                            finalidad de
                            mantenerles un sitio de acuerdo a sus preferencias locales (tales como navegador web usado,
                            sistema operativo, ISP, etc.). Las "cookies" permiten entregar un contenido ajustado a los
                            intereses y necesidades de nuestros usuarios/visitantes.
                        </p>
                    </div>
                </div>
                }
                @case ('uso-cookies') {
                <div class="text-secondary-400">
                    <p>
                        El uso de cookies y su dirección IP, tomados por este sitio, se realiza solo con la finalidad de
                        mantenerles un sitio de acuerdo a sus preferencias locales (tales como navegador web usado,
                        sistema
                        operativo, ISP, etc.). Las "cookies" permiten entregar un contenido ajustado a los intereses y
                        necesidades de nuestros usuarios/visitantes.
                    </p>
                </div>
                }
                }
            </div>
            <div class="modal-footer border-top py-2">
                <button type="button" class="btn btn-secondary-400 rounded-pill px-3 py-1 fs-7" data-bs-dismiss="modal">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>